window.addEventListener("load", function () {
    document.querySelectorAll('.ctaSlider').forEach(function (element) {
        const thumbsEl = element.querySelector(".thumbs");
        const contentEl = element.querySelector(".content");

        if (!thumbsEl || !contentEl) {
            return;
        }

        const backgroundsOuter = element.querySelectorAll(".backgrounds.outer > *");
        const backgroundsInner = element.querySelectorAll(".backgrounds.inner .background");

        const updateBackgrounds = (activeIndex) => {
            backgroundsOuter.forEach((bg, index) => {
                bg.style.display = index === activeIndex ? 'block' : 'none';
            });
            backgroundsInner.forEach((bg, index) => {
                bg.style.display = index === activeIndex ? 'block' : 'none';
            });
        };

        const thumbSwiper = new Swiper(thumbsEl, {
            effect: "coverflow",
            grabCursor: true,
            loop: true,
            scale: 0.85,
            centeredSlides: true,
            slidesPerView: 1,
            coverflowEffect: { rotate: 0, stretch: -40, depth: 200, modifier: 2, slideShadows: true },
            breakpoints: {
                560:  { coverflowEffect: { rotate: 0, stretch: -65,  depth: 200, modifier: 2, slideShadows: true } },
                900:  { coverflowEffect: { rotate: 0, stretch: -90,  depth: 200, modifier: 2, slideShadows: true } },
                1024: { coverflowEffect: { rotate: 0, stretch: -80,  depth: 200, modifier: 1, slideShadows: true } },
                1200: { coverflowEffect: { rotate: 0, stretch: -100, depth: 300, modifier: 3, slideShadows: true } },
                1600: { coverflowEffect: { rotate: 0, stretch: -130, depth: 300, modifier: 3, slideShadows: true } },
                1800: { coverflowEffect: { rotate: 0, stretch: -140, depth: 300, modifier: 3, slideShadows: true } },
                2200: { coverflowEffect: { rotate: 0, stretch: -180, depth: 300, modifier: 3, slideShadows: true } },
            },
        });

        const contentSwiper = new Swiper(contentEl, {
            slidesPerView: 1,
            effect: "fade",
            fadeEffect: { crossFade: true },
            pagination: {
                clickable: true,
                el: element.querySelector(".swiper-pagination"),
            },
        });

        // Synchronisierung beider Swiper (ohne Controller-Modul)
        thumbSwiper.on('slideChange', function () {
            if (contentSwiper.activeIndex !== thumbSwiper.activeIndex) {
                contentSwiper.slideTo(thumbSwiper.activeIndex);
            }
        });

        contentSwiper.on('slideChange', function () {
            if (thumbSwiper.activeIndex !== contentSwiper.activeIndex) {
                thumbSwiper.slideTo(contentSwiper.activeIndex);
            }
            updateBackgrounds(contentSwiper.activeIndex);
        });

        // Initialzustand
        updateBackgrounds(contentSwiper.activeIndex);
    });
});
